const PERMISSION_KEY= "crm:workflow_trigger_user";
const PAGE_URL = {
    WORKFLOW_TRIGGER_USER_PAGE: "/admin/crm/workflow-trigger-user"
}

export {PERMISSION_KEY, PAGE_URL}

